import { Group, Switch, Text } from "@mantine/core";
import React from "react";

const SwitchWithTitle: React.FC<{
  title?: string;
  onSave: (value: boolean) => void;
  checked: boolean;
}> = ({ title, onSave, checked }) => {
  return (
    <Group gap="sm" align="center">
      <Switch checked={checked} onChange={(event) => onSave(event.currentTarget.checked)} />
      {title && <Text fw={500}>{title}</Text>}
    </Group>
  );
};

export default SwitchWithTitle;
